import { Component, OnInit, HostListener } from "@angular/core";
import { ApiService } from "../services/api.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from '@angular/router';
import { CartService } from "../services/cart.service";
import { BreadcrumbsService } from "../services/breadcrumbs.service";
import { AuthService } from "../services/auth.service";
import { ServersService } from "../services/servers.service";

@Component({
    selector: "services-list",
    templateUrl: "./service-offer.component.html",
    styleUrls: ['../../assets/sass/checkout.scss']
})
export class ServiceOfferComponent implements OnInit {
    services = [];
    for_service_uuid: string;
    servicesLoading: any = true;
    serviceID = '';

    constructor(
        private apiService: ApiService,
        private route: ActivatedRoute,
        private router: Router,
        private cartService: CartService,
        private breadcrumbsService: BreadcrumbsService
    ) {
        this.for_service_uuid = null;
        this.servicesLoading = true;
        
    }

    ngOnInit() {
        this.for_service_uuid = null;
        this.servicesLoading = true;
        this.route.queryParams.subscribe(params => {
            this.serviceID = params['for_service'] || null;
            if (this.serviceID) {
                this.breadcrumbsService.translateBreadcrumb(
                    `/service/offer?for_service=${this.serviceID}`, 'Pobieranie listy usług wybranej pozycji');
                this.for_service_uuid = this.serviceID;
                this.apiService.get('/offer/services?for_service=' + this.serviceID).subscribe(response => {
                    this.services = response.services;
                    this.servicesLoading = false;
                    if (response.server) {
                        this.breadcrumbsService.translateBreadcrumb(
                            `/service/offer?for_service=${this.serviceID}`, 'Dostępne usługi dla ' + response.server);
                        return;
                    }
                    this.breadcrumbsService.translateBreadcrumb(
                        `/service/offer?for_service=${this.serviceID}`, 'Dostępne usługi do wykupienia');

                });
                return;
            }
            this.breadcrumbsService.translateBreadcrumb(
                `/service/offer`, 'Lista usług dostępnych do wykupienia');
            this.apiService.get('/offer/services').subscribe(response => {
                this.services = response.services;
            });
            this.servicesLoading = false;
        });
    }

    goToCompanySelect() {
        this.router.navigateByUrl('/service/offer/company');
    }

    isQuantifiable(service) {
        if (service.min === service.max) {
            return false;
        }
        return true;
    }

    getServiceSelectedValue(service) {
        return typeof service.selectedValue == 'string' && service.selectedValue.match(/^\d((\.|\,)[0]+)?$/) ?
            parseInt(service.selectedValue) :
            service.selectedValue;
    }

    addPositionToCart(service) {
        this.cartService.storeCartPosition(this.for_service_uuid, service, this.getServiceSelectedValue(service), 'service');
    }

    addQuantity(service) {
        if (parseFloat(service.selectedValue) + parseFloat(service.step) <= parseFloat(service.max)) {
            service.selectedValue = parseFloat(service.selectedValue) + parseFloat(service.step);
        }
    }

    subtractQuantity(service) {
        if (parseFloat(service.selectedValue) - parseFloat(service.step) >= parseFloat(service.min)) {
            service.selectedValue = parseFloat(service.selectedValue) - parseFloat(service.step);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/service/service-offer.component.ts